import { Head, router } from '@inertiajs/react'
import { useState } from 'react'
import { HiOutlineArrowLeft } from 'react-icons/hi2'
import AppLayout from '../../components/AppLayout'
import UserForm, { UserFormValues } from '../../components/UserForm'

type Props = {
  user: UserFormValues
  errors: Record<string, string[] | undefined>
}

export default function NewUser({ user, errors }: Props) {
  const [processing, setProcessing] = useState(false)

  const handleSubmit = (values: UserFormValues) => {
    setProcessing(true)
    router.post('/users', { user: values }, {
      onFinish: () => setProcessing(false),
    })
  }

  return (
    <>
      <Head title="Create User" />
      <AppLayout active="users">
        <div className="-mt-4 mb-8 flex items-center gap-6">
          <a
            href="/users"
            className="flex h-10 w-10 items-center justify-center rounded-full border border-gray-300 bg-white text-gray-700 transition hover:bg-gray-50"
            aria-label="Back to users"
          >
            <HiOutlineArrowLeft className="h-5 w-5" />
          </a>
          <h1 className="font-display text-2xl font-semibold text-gray-900">Create User</h1>
        </div>

        <UserForm
          initialValues={user}
          errors={errors}
          submitLabel="Create User"
          cancelHref="/users"
          onSubmit={handleSubmit}
          processing={processing}
        />
      </AppLayout>
    </>
  )
}
